window.Vue = require('vue');
require("./util");
require("./services/api");

import VueTheMask from 'vue-the-mask';
import Swal from 'sweetalert2';
import money from 'v-money';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import VuejsDialog from 'vuejs-dialog';

const toastOptions = {
  timeout: 3000
};
Vue.use(Toast, toastOptions);

window.Viewer = Viewer;
window.Swal = Swal;
Vue.use(VueTheMask);
Vue.use(money, {precision: 2})
Vue.use(VuejsDialog, {
  okText: 'OK',
  cancelText: 'Cancelar',
});
window.axios = require('axios');
window.moment = require('moment');

import Velocity from 'velocity-animate'
window.Velocity = Velocity;

Vue.component('v-select', vSelect);

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

/**
 * Observação
 *
 * Essa é uma medida provisória. deve-se tirar as tags <styles> aos poucos,
 * e adicionar os estilos em arquivos específicos para isso.
 * Depois que todos forem removidos, poderá retirar essa verificação.
 *
 * O Vue não funcionará em páginas onde tem tags <style>
 */
const isVuePage = document.querySelector("#vue-page");
const hasStyle = document.querySelector("#app style");
const app = isVuePage && !hasStyle && new Vue({
  el: '#vue-page',
});

if (app) {
  console.log("### Running with Vue! ###")
}

window.loadVueForm = () => {
  const isVuePage = document.querySelector("#div-form #vue-page");
  const hasStyle = document.querySelector("#div-form #vue-page style");
  const app = isVuePage && !hasStyle && new Vue({
    el: '#div-form #vue-page',
  });

  if (app) {
    console.log("### Form running with Vue! ###")
  }
}
